import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleIndustry = (id) => {
  return useQuery({
    queryKey: ['viewIndustryDetails', id],
    enabled: !!id, 
    queryFn: async ({ queryKey }) => {
      const industryId = queryKey[1];   
      const res = await api.get(`/industries/show/${industryId}`);
      return res.data;
    },
  });
};